export const passwordRequirementsText =
	"Use 10-128 characters with at least one letter and one number. Do not start or end with a space."

export function getPasswordValidationError(password: string): string | null {
	if (password.length < 10 || password.length > 128) {
		return "Password must be 10-128 characters."
	}
	if (password.trim() !== password) {
		return "Password can't start or end with a space."
	}
	if (!/\p{L}/u.test(password)) {
		return "Password must include at least one letter."
	}
	if (!/\p{N}/u.test(password)) {
		return "Password must include at least one number."
	}
	return null
}

export const isPasswordValid = (password: string): boolean => getPasswordValidationError(password) === null
